<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>필드 구성하기</h2>
        <p>인증 필드 (필수)</p>
        <p>
          인증 시 입력받아야 하는 필드 들을 추가하세요. 기본 필드를 생성해드리지
          않습니다.
        </p>
      </div>
      <div class="body table-responsive">
        <table class="table m-b-0">
          <thead class="thead-light">
            <tr>
              <th scope="col">키</th>
              <th scope="col">라벨</th>
              <!-- <th scope="col">필수</th> -->
              <th scope="col">타입</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-for="(field, index) in fieldsList" v-bind:key="index">
            <tr>
              <td>{{ replaceFieldText(field.keys) }}</td>
              <td>{{ setFieldField(field.label, field.keys) }}</td>
              <!-- <td>-</td> -->
              <td style="text-align: revert">
                {{ setFieldField(field.type, "string") }}
              </td>
              <td>
                <a href="javascript:void(0);" @click="editPage(index)">수정</a>
                &nbsp;&nbsp;&nbsp;
                <a href="javascript:void(0);" @click="deleteAuth(index)"
                  >삭제</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="text-align: right; margin-bottom: 10px">
      <button type="button" class="btn btn-default" @click="toAddingFieldPage">
        추가</button
      >&nbsp;
      <!-- <button type="button" class="btn btn-primary">계속</button> -->
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";
// import DevAuthField from "@/views/dev/auth/DevAuthField"

export default {
  name: "tabs",

  data() {
    return {
      fieldsList: [],
    };
  },
  methods: {
    createKeyValue: function (num) {
      console.log("d" + num);
    },
    toAddingFieldPage() {
      this.$router.push({
        name: "DevAuthField",
        params: {
          fieldnum: this.fieldsList.length,
        },
      });
    },
    editPage(index) {
      this.$store.state.devStore.apiSchema = this.fieldsList[index];
      this.$router.push({
        name: "DevAuthField",
        params: { fieldnum: index },
      });
    },
    deleteAuth(index) {
      if (confirm("삭제하시겠습니까?")) {
        var param = {
          apiCode: this.$store.state.devStore.apiCode,
          where: "field",
          count: index,
        };

        this.api.deleteApiSchema(param)
          .then((res) => {
            console.log("결과 : ", res);

            // this.$store.dispatch("apiDetail").then(() => {

            //   this.$store.state.devStore.apiSchema = null
            //   console.log(this.$store.state.devStore.formsData)
            //   this.fieldsList = this.$store.state.devStore.formsData

            // })

            // eventbus.$emit('menuReset')
            this.getDetails();
          })
          .catch(() => alert("오류가 발생했습니다. > 필드 부분"));
      }
    },
    getDetails() {
      console.log("디테일로 넘어왔나");
      this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{

            this.$store.dispatch("apiDetail", {result : res}).then(() => {
              this.$store.state.devStore.apiSchema = null;
              console.log(this.$store.state.devStore.formsData);
              if (this.$store.state.devStore.formsData.length > 0) {
                this.fieldsList = this.$store.state.devStore.formsData;
              } else {
                this.fieldsList = [];
                this.removeAuth();
              }

              // eventbus.$emit('checkFormCount')
            });

          })
    },
    removeAuth() {
      //  eventbus.$on('checkFormCount', ()=>{
      var authForm = JSON.parse(this.$store.state.devStore.apiAuth[0].apiSchema)
        .design.forms;
      console.log("삭제 후 체 크 :", authForm.length);

      if (authForm.length == 0) {
        // var param = {
        //     apiCode: this.$store.state.devStore.apiAuth[0].apiCode
        // };

        // this.$store
        //     .dispatch("postSend", {
        //     paths: Apiroot.api + Urls.resetAuth,
        //     params: param,
        //     })
        //     .then((res) => {
        //     console.log("데이터 : ", res);

        //     this.$store.state.devStore.apiAuth.push(res.api)

        eventbus.$emit("resetFormList");

        //     })
        //     .catch(() => alert("오류가 발생했습니다. auth 2"));
      }

      // eventbus.$off('checkFormCount')

      // })
    },
    replaceFieldText(text) {
      console.log("text:", text);

      return text.replace(/"/gi, "");
    },

    setFieldField(value, replaceValue) {
      console.log(value, replaceValue);

      if (value != undefined) {
        value = value.replace(/"/gi, "").replace(/\s/gi, "");
      }

      if (value == null || value == "null" || value == "") {
        console.log(true);
        return replaceValue.replace(/"/gi, "");
      } else {
        console.log(false);
        return value.replace(/"/gi, "");
      }
    },
  },

  mounted() {},
  created() {
    this.$store.state.devStore.apiSchema = null;
    console.log(this.$store.state.devStore.formsData);
    this.fieldsList = this.$store.state.devStore.formsData;
  },
};
</script>
